import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="comprar" className="relative py-28 md:py-32 px-4 overflow-hidden bg-gradient-to-b from-[#F7F3E9] to-white" data-id="element-47">
      {/* Soft decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#FFD166]/15 via-transparent to-transparent blur-3xl pointer-events-none" data-id="element-48"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-50">
          <p className="text-xl text-[#F4A261] font-serif italic mb-6" data-id="element-51">
            Tu momento es ahora
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif text-[#2F3A3D] mb-8 leading-tight" data-id="element-52">
            Empieza hoy tu camino hacia una vida más clara, tranquila y llena de
            esperanza.
          </h2>
          <p className="text-xl text-[#5F6368] max-w-xl mx-auto leading-relaxed" data-id="element-53">
            Da el primer paso hacia tu bienestar emocional.
          </p>
        </motion.div>
      </div>
    </section>;
}